import { useState } from "react";
import { Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";
import useTitle from "../Hooks/useTitle";

const VideoTutorials = () => {
  useTitle('Tutorials Video');
  const { t } = useTranslation("video_tutorials");
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className="grid gap-6  p-8  py-6  mt-[76px] sm:ml-[300px]">
        <div className=" items-center z-[1] ">
          <span className="font-[600] text-[26px]">{t("header")}</span>
        </div>
        {loading ? (
          ""
        ) : (
          <p className="text-[#535861] text-[14px]">
            {t("welcome_message")} {t("description")}
          </p>
        )}
        {loading ? (
          <div className=" w-full flex justify-items-between grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 shrink bg-white rounded-[20px] p-6">
            {[1, 2, 3, 4, 5].map((items, i) => (
              <div className="menuitem rounded-[20px]  cursor-pointer w-full pt-8 ">
                <div className="div h-[180px] rounded-[20px]">
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    className="rounded-[20px]"
                    height={180}
                  />
                </div>
                <div className="p-2">
                  <Skeleton width="40%" height={20} />
                  <Skeleton width="80%" height={20} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className=" bg-white p-6  flex flex-col  rounded-[20px] w-full">
            <span className="font-[600] text-[20px]">{t("card_title")}</span>
            <div className="mt-2 w-full flex justify-items-between grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 shrink">
              <div className="w-full">
                <iframe
                  src="https://player.vimeo.com/video/1048804394"
                  className="w-full h-[200px]"
                  name="tutorial-1"
                  title="tutorial-1"
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="w-full">
                <iframe
                  src="https://player.vimeo.com/video/1048804401"
                  className="w-full object-cover h-[200px]"
                  name="tutorial-2"
                  title="tutorial-2"
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="w-full">
                <iframe
                  src="https://player.vimeo.com/video/1048804413"
                  className="w-full object-cover h-[200px]"
                  name="tutorial-3"
                  title="tutorial-3"
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="w-full">
                <iframe
                  src="https://player.vimeo.com/video/1048804424"
                  className="w-full object-cover h-[200px]"
                  name="tutorial-4"
                  title="tutorial-4"
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="w-full">
                <iframe
                  src="https://player.vimeo.com/video/1048804445"
                  className="w-full object-cover h-[200px]"
                  name="tutorial-5"
                  title="tutorial-5"
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default VideoTutorials;
